import {
  Accordion,
  HStack,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Box } from '@chakra-ui/react';
import { format } from 'date-fns';

export const MeetingHeader = ({ item }) => {
  const meetingStatus = item.pm_status ? `[${item.pm_status}]` : '';
  const dateObj = new Date(item.meeting_date);
  const meetingDate = format(dateObj, "MM-dd-yyyy 'at' hh:mm:ssXXX");

  return (
    <Box py={2}>
      <HStack justifyContent={'space-between'} alignItems={'flex-start'}>
        <Accordion.Icon
          color={'black'}
          style={{
            //@ts-ignore
            cursor: 'pointer',
            paddingTop: 2,
          }}
        />
        <VStack px={1}>
          <Text fontSize={'md'} fontWeight={'normal'}>
            {meetingDate}
          </Text>
          <Text>{meetingStatus}</Text>
        </VStack>
      </HStack>
    </Box>
  );
};
